import { render, staticRenderFns } from "./OrderImportModal.vue?vue&type=template&id=e8d8a820&scoped=true&lang=html&"
import script from "./OrderImportModal.vue?vue&type=script&lang=js&"
export * from "./OrderImportModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderImportModal.vue?vue&type=style&index=0&id=e8d8a820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d8a820",
  null
  
)

export default component.exports